import { msalInstance } from '../components/WithAuth';
import environment from '../environments/environment';

export const getToken = async (scopes?: string[]) => {
  const isAuth = !!msalInstance.getActiveAccount();
  if (!isAuth) {
    return null;
  }
  try {
    const { accessToken } = await msalInstance.acquireTokenSilent({
      scopes: scopes || environment.loginScopes,
    });
    return accessToken;
  } catch (error) {
    const { accessToken } = await msalInstance.acquireTokenPopup({
      scopes: scopes || environment.loginScopes,
    });
    return accessToken;
  }
};
